import React, {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, EffectFade, Keyboard, Navigation, Pagination} from 'swiper/modules';

import {hooks} from '../hooks';
import {Screens} from '../enums';
import {actions} from '../store/actions';
import {salon, salonHeroSlides} from '../config/salon';

export const HeroSlider: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);

  useEffect(() => {
    if (!galleryOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [galleryOpen]);

  const openGallery = (index: number) => {
    setGalleryIndex(index);
    setGalleryOpen(true);
  };

  const renderGallery = (): JSX.Element | null => {
    if (!galleryOpen) return null;

    return (
      <div
        className='salon-gallery'
        role='dialog'
        aria-modal='true'
      >
        <button
          className='salon-gallery__close'
          onClick={() => setGalleryOpen(false)}
          type='button'
          aria-label='Galeriyi kapat'
        >
          ×
        </button>
        <Swiper
          key={galleryIndex}
          className='salon-gallery__slider'
          initialSlide={galleryIndex}
          keyboard={{
            enabled: true,
          }}
          loop={true}
          modules={[Keyboard, Navigation, Pagination]}
          navigation={true}
          pagination={{
            clickable: true,
          }}
        >
          {salonHeroSlides.map((slide) => {
            return (
              <SwiperSlide key={slide.id}>
                <div className='salon-gallery__slide'>
                  <img
                    className='salon-gallery__image'
                    src={slide.image}
                    alt={slide.alt}
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  };

  return (
    <>
      <section className='salon-hero'>
        <div className='salon-hero__shell'>
          <Swiper
            autoplay={{
              delay: 4300,
              disableOnInteraction: false,
            }}
            className='salon-hero__slider'
            effect='fade'
            loop={true}
            modules={[Autoplay, EffectFade, Pagination]}
            pagination={{
              clickable: true,
            }}
            speed={800}
          >
            {salonHeroSlides.map((slide, index) => {
              return (
                <SwiperSlide key={slide.id}>
                  <button
                    className='salon-hero__image-button'
                    onClick={() => openGallery(index)}
                    type='button'
                    aria-label={`${slide.alt} galerisini aç`}
                  >
                    <img
                      className='salon-hero__image'
                      src={slide.image}
                      alt={slide.alt}
                    />
                  </button>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className='salon-hero__cta-card salon-actions'>
            <a
              className='salon-button salon-button--light'
              href={salon.phoneHref}
            >
              Randevu Al
            </a>
            <button
              className='salon-button salon-button--dark'
              onClick={() => dispatch(actions.setScreen(Screens.Search))}
              type='button'
            >
              Hizmetler
            </button>
          </div>
        </div>
      </section>
      {renderGallery()}
    </>
  );
};
